var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96289 16.6917L9.06189 19.0976C9.46176 19.4986 10.3615 19.6991 10.9613 19.6991H14.7601C15.9597 19.6991 17.2592 18.7969 17.5592 17.5939L19.9584 10.276C20.4582 8.87257 19.5585 7.66963 18.059 7.66963H14.0603C13.4605 7.66963 12.9606 7.1684 13.0606 6.46669L13.5604 3.25884C13.7604 2.35663 13.1606 1.35418 12.2609 1.05344C11.4611 0.752705 10.4614 1.15369 10.0616 1.75516L5.96289 7.87012",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 16.6916V6.86755C0.863281 5.46412 1.46309 4.96289 2.86264 4.96289H3.86231C5.26186 4.96289 5.86167 5.46412 5.86167 6.86755V16.6916C5.86167 18.095 5.26186 18.5962 3.86231 18.5962H2.86264C1.46309 18.5962 0.863281 18.095 0.863281 16.6916Z",
    stroke: "#DEDFE1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.9e1a4fec76f060117429b23b5fa74ab7.svg";
export { ForwardRef as ReactComponent };